module.exports = __webpack_public_path__ + "static/media/badge_support_1.a0acef0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_support_1.png
// module id = 495
// module chunks = 0